import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./JdPower2023.module.scss";

/**
 * Native port of
 * ``cms/blocks/hc-block/hc-block--jdpower-2023--banner-triple.html``.
 *
 * Legacy ``static_image`` renders EAGER under puppeteer (plain ``<img>`` with
 * the static URL); the ``src`` is built from the reactivated ``STATIC_URL``
 * context (``useStaticURL``) -- SSR-safe and byte-identical to the legacy
 * ``{% static %}`` output, unlike a Vite asset import. Presentational
 * ``height``/``width`` attrs are preserved verbatim (load-bearing for
 * sizing). The ``<sup>+</sup>`` is kept directly adjacent to the preceding text
 * (no whitespace).
 */
export const JdPower2023BannerTriple = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className={concatClassNames([styles.banner, styles.triple])}>
            <div>
                <img
                    src={`${staticURL}img/hardcoded/jdpower-2023--triple.png`}
                    alt="2023 JD Power Award Trophy"
                    height="131px"
                    width="162px"
                    className={styles.imageTriple}
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>
                        #1 in Customer Satisfaction with Mattresses Purchased
                        Online
                    </h3>
                    <p>
                        — Awarded by J.D. Power in 2023, 2022 & 2021<sup>+</sup>
                    </p>
                </div>
            </div>
        </div>
    );
};
